/*
 * @Author: Teemo Ding
 * @Date: 2021-09-15 11:30:26
 * @LastEditTime: 2021-09-22 09:29:45
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/Edit/Domain/index.tsx
 */
import { Button, Form, Input, Label } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { SSLStatusType } from '@/src/types/common/domain';
import { domainValid, rootDomainValid } from 'src/tools/regExp';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const { Item } = Form;

const Domain = ({ domain, confirmDomain, status }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [editing, setEditing] = useState(false);

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('salesChannelDomainAndStatus.edit.domain')}>
      {domain && !editing ? (
        <div>{domain}</div>
      ) : (
        <Item
          name='domain'
          className={css.domainItem}
          validateFirst={true}
          rules={[
            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.resolve();
                }

                if (rootDomainValid.test(value)) {
                  return Promise.reject(
                    new Error(
                      getI18n(
                        'salesChannelDomainAndStatus.edit.rootdomainValid',
                      ),
                    ),
                  );
                }
                return Promise.resolve();
              },
            },
            {
              required: true,
              pattern: domainValid,
              message: getI18n(
                'salesChannelDomainAndStatus.edit.thisfieldmustbeavalidURL',
              ),
            },
          ]}
          label={
            <Label
              title={getI18n('salesChannelDomainAndStatus.edit.domain')}
              rightSubTitle={getI18n(
                'salesChannelDomainAndStatus.edit.domainsubtitle',
              )}
            />
          }
          labelCol={{ span: 24 }}>
          <Input
            placeholder='e.g. shop.example.com'
            size='large'
            className={css.domainItemInput}
          />
        </Item>
      )}
      {status !== SSLStatusType.Verified ? (
        domain ? (
          <></>
        ) : (
          <Form.Item shouldUpdate={(prev, curr) => prev.domain !== curr.domain}>
            {({ getFieldValue }) => {
              const currentDomain = getFieldValue('domain') || '';
              const isRootDomain =
                currentDomain && rootDomainValid.test(currentDomain);
              const isInvalidSubDomain =
                currentDomain && !domainValid.test(currentDomain);
              const shouldDisable =
                !currentDomain || isRootDomain || isInvalidSubDomain;

              return (
                <Button
                  type='primary'
                  onClick={() => {
                    confirmDomain(['domain']);
                    setEditing(false);
                  }}
                  disabled={shouldDisable}
                  className={css.primaryButton}>
                  {getI18n('general.confirm')}
                </Button>
              );
            }}
          </Form.Item>
        )
      ) : null}
      {/* {editing && (
        <Button onClick={handleCancelEdit}>{getI18n('general.cancel')}</Button>
      )} */}
    </SectionWrapper>
  );
};

export default Domain;
